/**
 * 后续新增语言类型需要在这里单独导入
 */
import 'dayjs/locale/zh-cn' // 中文
import 'dayjs/locale/ar' // 阿拉伯文
import 'dayjs/locale/es' // 西班牙语
import 'dayjs/locale/fr' // 法语
import 'dayjs/locale/ru' // 俄罗斯语

interface MomentLocalMapType {
  [key: string]: string
}

/**
 * dayjs 对应的枚举类型
 */
export const MOMENT_LOCALE_MAP: MomentLocalMapType = {
  en: 'en',
  zh: 'zh-cn',
  ar: 'ar', // 阿拉伯文
  fr: 'fr', // 法语
  ru: 'ru', // 俄罗斯语
  es: 'es', // 西班牙语
}
